export default "__VITE_ASSET__BNZnB5Al__"